module.exports = __webpack_public_path__ + "04_mole.901dc841.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/04_mole.png
// module id = tWwh
// module chunks = 0